import Chart from "react-apexcharts";
import React, { useState, useEffect } from 'react';
import { Row, Col, } from 'antd';

const ScatterCharts = ({
    series = [
        {
            name: '外部會議',
            data: [
                [new Date(2014, 1, 2).getTime(), 20]
            ]
        },
        {
            name: '跨部門會議',
            data: [
                [new Date(2014, 1, 3).getTime(), 20]
            ]
        },
        {
            name: '單一部門會議',
            data: [[new Date(2014, 1, 4).getTime(), 20]]
        },
    ]
}) => {
    const options = {
        chart: {
            height: 350,
            type: 'scatter',
            zoom: {
                type: 'xy'
            }
        },
        dataLabels: {
            enabled: false
        },
        grid: {
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
        },
        xaxis: {
            type: 'datetime',
            labels: {
                datetimeFormatter: {
                    year: 'yyyy',
                    month: "yyyy/MM",
                    day: 'yyyy/MM/dd',
                    hour: 'HH:mm',
                },
            },
        },
        yaxis: {
            max: 1000
        },
        markers: {
            size: 10
        }
    }
    return (<Row>
        <Col span={24}>
            <Chart
                options={options}
                series={series}
                type="scatter"
                width="100%"
            />
        </Col>
    </Row>)
}
export { ScatterCharts }